import type { RootState } from 'store/configureStore';
import { getComponentsById } from 'store/quotes/selectors';
import type { ActionWithPayload } from 'store/types';

import * as types from './types';

type BulkEditProfitItemsDrawerAction =
  | ActionWithPayload<typeof types.OPEN, { componentIds: number[] }>
  | ActionWithPayload<typeof types.CLOSE>;

type BulkEditProfitItemsDrawerState = {
  isOpen: boolean;
  componentIds: number[];
};

const initialState: BulkEditProfitItemsDrawerState = {
  isOpen: false,
  componentIds: [],
};

const reducer = (
  state = initialState,
  action: BulkEditProfitItemsDrawerAction,
): BulkEditProfitItemsDrawerState => {
  switch (action.type) {
    case types.OPEN: {
      const { componentIds } = action.payload;
      return { ...state, isOpen: true, componentIds };
    }

    case types.CLOSE:
      return { ...initialState };

    default:
      return state;
  }
};

const getScope = (state: RootState): BulkEditProfitItemsDrawerState =>
  state.modules.quotes.quoteItemNav.bulkEditProfitItemsDrawer;

export const getIsOpen = (state: RootState) => getScope(state).isOpen;

export const getComponents = (state: RootState) =>
  getComponentsById(state, getScope(state).componentIds);

export default reducer;
